export const dateToTimeToken = (date: Date) => {
  return (Math.floor(date.getTime() / 1000) * 10000000).toString();
};
